module.exports = __webpack_public_path__ + "img/female-comment.6332b8e9.jpg";